import React from 'react';
import TextLink from '../TextLink';
import editOnGitHubUrl from '../../editOnGitHubUrl';

const EditOnGitHubLink = ({ siteMetadata, template: node }: any) => {
  return (
    <TextLink
      to={editOnGitHubUrl({ siteMetadata, node, nodeSourcePath: '/content/backstage/plugins' })}
      color="primary"
    >
      Update these instructions
    </TextLink>
  );
};

export default EditOnGitHubLink;
